var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { LangHelper } from "../../components/_common/lang/helper";
import { ActionType } from "../enums/action-type";
import { LocalStorageKeys } from "../enums/local-storage-keys";
export var initialState = {
    lang: LangHelper.getDefaultLang(),
    langList: [],
};
var contextValue = {
    // eslint-disable-next-line sort-keys
    dispatch: function () { },
    state: initialState,
};
export var FormContext = React.createContext(contextValue);
export var reducer = function (state, action) {
    switch (action.type) {
        case ActionType.RESET: {
            return __assign({}, state);
        }
        case ActionType.CHANGE_LANG: {
            var lang = action === null || action === void 0 ? void 0 : action.lang;
            localStorage.setItem(LocalStorageKeys.SELECTED_LANG, lang);
            return __assign(__assign({}, state), { lang: lang });
        }
        case ActionType.REFRESH_LANG_LIST: {
            var langList = action === null || action === void 0 ? void 0 : action.langList;
            return __assign(__assign({}, state), { langList: langList });
        }
        default:
            return state;
    }
};
